import { CommonModule } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from '@shared/components/navbar/navbar.component';
import { SidebarComponent } from '@shared/components/sidebar/sidebar.component';
import { SkeletonLoadingComponent } from '@shared/components/skeleton-loading/skeleton-loading.component';
import { LoadingService } from '@core/services/loading.service';
import { SidebarMenuService } from '@core/services/sidebar-menu.service';
import { UserService } from '@core/services/user.service';

@Component({
  selector: 'app-layout-template',
  standalone: true,
  imports: [
    CommonModule,
    NavbarComponent,
    RouterOutlet,
    SidebarComponent,
    SkeletonLoadingComponent,
  ],
  templateUrl: './layout-template.component.html',
  styleUrl: './layout-template.component.scss',
})
export class LayoutTemplateComponent {
  private loadingService = inject(LoadingService);
  private sidebarMenuService = inject(SidebarMenuService);
  private userService = inject(UserService);

  isLoading: boolean = false;
  isSidebarOpen: boolean = false;

  constructor() {
    // Simulación temporal para Fase 1:
    // si no hay login (userName en storage vacío), completamos el username para probar UI.
    const SIMULATED_USERNAME = 'magnumlogisticsgen@magnum.com.co';
    if (!this.userService.userName()) {
      this.userService.setUserName(SIMULATED_USERNAME);
    }

    effect(() => {
      this.isLoading = this.loadingService.isLoading();
    });
    effect(() => {
      this.isSidebarOpen = this.sidebarMenuService.isSidebarOpen();
    });
  }
}
